import parsePhoneNumberFromString from 'libphonenumber-js';
import { Relref } from '../hugo';

const $searchbar = document.querySelector('#searchbar') as HTMLElement;
const $phoneEmailLinks = document.querySelector('#phone-email-links') as HTMLElement;
const $headerSearchLink = document.querySelector('#header-search-link') as HTMLElement;
const $searchCloseIcon = document.querySelector('#search-close-icon') as HTMLElement;
const $headerLinkIcons = Array.from(document.querySelectorAll('.header-link-icon'));
const $freeShippingText = document.querySelector('#free-shipping-text') as HTMLElement;
const $headerSearchInput = document.querySelector('#header-search-input') as HTMLInputElement;
const $headerSearchText = document.querySelector('#searchbarText') as HTMLInputElement;

$headerSearchLink.addEventListener('click', e => {
    e.preventDefault();

    if ($searchCloseIcon.innerText === 'search') {
        searchStateActive();
        $headerSearchText.focus();
        $headerSearchText.select();
    } else {
        searchStateInactive();
    }
});

const $headerSearchForm = $headerSearchText.closest('form') as HTMLFormElement;
$headerSearchText.addEventListener('input', () => {
    if (checkIfSearchForQuote($headerSearchText.value)) {
        $headerSearchForm.action = Relref('/quote-search');
    } else {
        $headerSearchForm.action = Relref('/search');
    }
});

const $mobileSearchInput = document.querySelector('#mobile-header-search-input') as HTMLInputElement;
const $mobileSearchForm = $mobileSearchInput.closest('form') as HTMLFormElement;
$mobileSearchInput.addEventListener('input', () => {
    if (checkIfSearchForQuote($mobileSearchInput.value)) {
        $mobileSearchForm.action = Relref('/quote-search');
    } else {
        $mobileSearchForm.action = Relref('/search');
    }
});

window.addEventListener('resize', () => {
    checkSearchState();
});

function checkSearchState() {
    if ($searchCloseIcon.innerText === 'search') {
        searchStateInactive();
    } else {
        searchStateActive();
    }
}

function searchStateActive() {
    $freeShippingText.classList.remove('d-xxl-block');
    $searchCloseIcon.innerText = 'close';
    $searchbar.classList.remove('d-none');
    if (window.innerWidth < 1200) {
        $phoneEmailLinks.classList.add('d-none');
        if (window.innerWidth < 768) {
            for (const $icon of $headerLinkIcons) {
                if (!($icon.id === 'header-search-link')) {
                    $icon.classList.add('d-none');
                }
            }
        } else {
            for (const $icon of $headerLinkIcons) {
                $icon.classList.remove('d-none');
            }
        }
    } else {
        $phoneEmailLinks.classList.remove('d-none');
    }
    $headerSearchInput.focus();
    $headerSearchInput.select();
}

function searchStateInactive() {
    $headerSearchInput.blur();
    $freeShippingText.classList.add('d-xxl-block');
    for (const $icon of $headerLinkIcons) {
        $icon.classList.remove('d-none');
    }
    $searchCloseIcon.innerText = 'search';
    $phoneEmailLinks.style.display = 'flex';
    $searchbar.classList.add('d-none');
    $phoneEmailLinks.classList.remove('d-none');
}

const quoteTest = /^#?\d{1,3}-\d+$/;
function checkIfSearchForQuote(t: string): boolean {
    // If it begins with a hash symbol, assume it's a quote, don't bother checking further
    if (t.startsWith('#')) {
        return true;
    }

    // Almost all quotes are 10 characters excluding the leading hash, like XXX-XXXXXX
    if (t.length >= 10 && quoteTest.test(t)) {
        return true;
    }

    // Shortest valid email is 6 characters, like a@b.cd
    if (t.length >= 6 && t.includes('@') && checkIfStringIsEmail(t)) {
        return true;
    }

    // Shortest reasonable US phone number is 10 characters, like 1234567890 for (123) 456-7890
    if (t.length >= 10 && parsePhoneNumberFromString(t, 'US')) {
        return true;
    }

    return false;
}

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
function checkIfStringIsEmail(t: string): boolean {
    if (typeof document !== 'undefined' && 'createElement' in document) {
        const input = document.createElement('input');
        input.type = 'email';
        input.value = t;
        if (typeof input.checkValidity === 'function') {
            return input.checkValidity();
        }
    }
    return emailRegex.test(t);
}
